import { Controller } from "stimulus";

export default class extends Controller {
  lockSelected(event) {
    event.preventDefault();
    event.stopPropagation();

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) headers["X-CSRF-Token"] = token.getAttribute("content");

    const tableType = this.element.dataset.table;
    const shipmentId = this.element.dataset.shipmentId;
    const selectedRows = document.querySelectorAll(
      `.${tableType}-items-table input[name="transaction_item_ids[]"]:checked`
    );

    if (selectedRows.length === 0) {
      alert("No items selected for locking.");
      return;
    }

    const selectedIds = Array.from(selectedRows).map((input) => input.value);
    fetch(`/admin/shipments/${shipmentId}/transaction_items/bulk_lock`, {
      method: "PATCH",
      headers,
      credentials: "same-origin",
      body: JSON.stringify({ transaction_item_ids: selectedIds }),
    })
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          console.error("bulk_lock failed", response.status, body);
          alert(body.message || `Lock failed (${response.status}). Check the console for details.`);
          return;
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error("bulk_lock request failed", error);
        alert("Lock request failed. Check the console for details.");
      });
  }
}
